import { mount } from "@vue/test-utils";
import FormValidator from "@/mixins/form-validator";

describe("FormValidator Component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(FormValidator);
  });

  it("Renders del component FormValidator", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });

  it("Debe devolver true si el objeto no es requerido", () => {
    expect(wrapper.vm.checkValid()).toBe(true);
  });
});
